import { Component, Inject, OnInit } from '@angular/core';
import { PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-gcoffline',
  templateUrl: './gcoffline.component.html',
  styleUrls: ['./gcoffline.component.scss']
})
export class GCOfflineComponent implements OnInit {

  k = 0;
  manual = false;
  off = false;
  fixA = false;
  fixB = false;

  status = '';
  statusRight = '';
  pulsing = false;

  private timer: any;
  private t1: any;
  private t2: any;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngOnInit(): void {
    this.refresh();
  
    if (isPlatformBrowser(this.platformId)) {
      this.timer = setInterval(() => {
        this.k += 1;
  
        if (this.manual) {
          return;
        }
  
        const phase = this.k % 10;
        this.off = phase >= 3;
        this.fixA = phase >= 5;
        this.fixB = phase >= 7;
        this.refresh();
      }, 700);
    }
  }

  ngOnDestroy(): void {
    clearInterval(this.timer);
    clearTimeout(this.t1);
    clearTimeout(this.t2);
  }

  toggle(): void {
    const nOff = !this.off;
    this.manual = true;
    this.off = nOff;
    if (nOff) {
      this.fixA = false;
      this.fixB = false;
      clearTimeout(this.t1);
      clearTimeout(this.t2);
      this.t1 = setTimeout(() => { this.fixA = true; this.refresh(); }, 900);
      this.t2 = setTimeout(() => { this.fixB = true; this.refresh(); }, 1700);
    }
    this.refresh();
  }

  private refresh(): void {
    const done = this.fixA && this.fixB;
    this.status = this.off ? (done ? 'Offline · 2 fixes made on this device' : 'Offline · still checking on this device') : 'Online';
    this.statusRight = this.off ? 'Nothing sent to the cloud' : 'Turn Wi-Fi off to try it';
    this.pulsing = this.off && !done;
  }


  buildPlanCheckoutUrl(
    planType: string,
    opts: {
      coupon?: string;
      utm_source?: string;
      utm_medium?: string;
      utm_campaign?: string;
      utm_id?: string;
    } = {}
  ) {
    const {
      coupon,
      utm_source,
      utm_medium,
      utm_campaign,
      utm_id
    } = opts;
  
    const payload = {
      frmktg: true,
      go_to_payments: true,
      plan_type: planType,
      planType: planType,
      plan_name: 'basic'
    };
  
    const jsonPayload = encodeURIComponent(JSON.stringify(payload));

    let encoded = '';
    
    if (isPlatformBrowser(this.platformId)) {
      encoded = btoa(jsonPayload).replace(/=/g, '');
    } else {
      encoded = Buffer.from(jsonPayload).toString('base64').replace(/=/g, '');
    }
  
    const params = new URLSearchParams();
  
    if (coupon) params.set('cp', coupon);
    if (utm_source) params.set('utm_source', utm_source);
    if (utm_medium) params.set('utm_medium', utm_medium);
    if (utm_campaign) params.set('utm_campaign', utm_campaign);
    if (utm_id) params.set('utm_id', utm_id);
  
    const query = params.toString();
  
    return `${environment.paymentsUrl}/user/${encoded}${query ? `?${query}` : ''}`;
  }
}
